<template>
  <div class="wrapper">
    <div class="head l_flex_row">
      <div class="name">排序：</div>
      <div @click="sortChange" class="sort l_flex_row">
        <div
          :data-index="index"
          :class="{ active: index == sortIndex }"
          class="sort-item"
          v-for="(item, index) in sortList"
          :key="index"
        >
          {{ item.name }}
          <span :data-index="index" :class="{'asc': item.sort=='asc'}" class="iconfont icon-arrow-down-filling"></span>
        </div>
      </div>
    </div>
    <div class="list">
      <dynamic
        :obj="item"
        class="item"
        v-for="(item, index) in datalist"
        :key="index"
      ></dynamic>
    </div>
    <div class="pagination l_flex_row_center">
      <el-pagination
        @current-change="handleCurrentChange"
        :current-page="currentPage"
        :page-size="10"
        layout="total,  prev, pager, next, jumper"
        :total="total"
      >
      </el-pagination>
    </div>
  </div>
</template>

<script>
import Dynamic from "@/components/Dynamic";
export default {
  components: {
    Dynamic,
  },
  props: {},
  data() {
    return {
      sortList: [
        { name: "时间", active: false, sort: "des", value:'created_at' },
        { name: "浏览", active: false, sort: "des", value:'views' },
      ],
      // des 降序 asc升序
      total: 1,
      datalist: [],
      sortIndex: 0,
      currentPage: 1,
      currentSort: "-created_at", //  -views倒叙views正序游览量-created_at 倒叙时间
    };
  },
  watch: {},
  computed: {},
  methods: {
    handleCurrentChange(e) {
      //
      this.currentPage = e;
      this.getActivityDynamics(this.currentPage, this.currentSort);
    },
    // 活动动态
    async getActivityDynamics(page,sort) {
      try {
        let res = await this.$api.getActivityDynamic({
          params: {
            page: page,
            sort: sort,
          },
        });
        console.log(res);
        this.datalist = res.data.list;
        this.total = res.data.num;
      } catch (error) {
        console.error("error", error);
      }
    },
    // 排序切换
    sortChange(e) {
      const {index} = e.target.dataset;
      console.log(e.target.dataset);
      if(index!=this.sortIndex){
        // 恢复其他选项
        this.sortList.forEach((item,item_index) => {
          if(item_index!=index){
            item.sort = 'des';
          }
        }) 
      }else{
        // 
        this.sortList[index].sort = this.sortList[index].sort =='des' ? 'asc':'des';
      }
      this.sortIndex = index;
      const rules = {
        'des': () => {
            return `-${this.sortList[index].value}` 
        },
        'asc': () => {
          return `${this.sortList[index].value}`
        }
      }
      this.currentSort = rules[this.sortList[index].sort]();
      this.getActivityDynamics(this.currentPage,this.currentSort)
    },
  },
  created() {
    this.getActivityDynamics(this.currentPage,this.currentSort);
  },
  mounted() {},
};
</script>
<style lang="scss" scoped>
.wrapper {
  background-color: #fff;
  width: 1200px;
  min-width: 1200px;
  margin: 0 auto 50px;
  min-height: 100vh;
  padding: 80px 64px;
  border-radius: 10px;
  box-sizing: border-box;
  .head {
    height: 40px;
    .name {
    }
    .sort {
      position: relative;
      &::before {
        content: "";
        display: block;
        position: absolute;
        left: 50%;
        top: 50%;
        transform: translate(-50%, -50%);
        width: 1px;
        height: 20px;
        background-color: #999;
      }
      .sort-item {
        margin: 0 15px;
        cursor: pointer;
        &.active {
          color: #815a4e;
        }
        & .asc{
          transform: rotate(180deg);
        }
        .iconfont{
          display: inline-block;
        }
      }
    }
  }
  .list {
    .item {
      margin-bottom: 40px;
      border-bottom: 1px solid #eeeeee;
      &:last-child {
        border-bottom: none;
      }
    }
  }
}
</style>